import { ReactNode } from 'react';
/**
 * 页面弹窗的容器
 * @param param0
 * @returns
 */
export const PageDialogWrapper = ({ children }: { children: ReactNode }) => {
  return <div className="absolute top-0 left-0 w-full h-full z-10 pr-5 py-4">{children}</div>;
};
